import noop from 'lodash/noop';
import { createActions } from 'redux-actions';

export const presenceActions = createActions(
  {
    PRESENCE_SET_STATUS: [
      (payload) => payload, // Payload
      (_payload, resolve = noop, reject = noop) => ({ resolve, reject }), // Meta
    ],
    PRESENCE_SET_MEDIA_CHANNEL: [
      (payload) => payload, // Payload
      (_payload, resolve = noop, reject = noop) => ({ resolve, reject }), // Meta
    ],
    PRESENCE_SET_MEDIA: [
      (payload) => payload, // Payload
      (_payload, resolve = noop, reject = noop) => ({ resolve, reject }), // Meta
    ],
    PRESENCE_SET_SIMULTANEOUS_RINGING: [
      (payload) => payload, // Payload
      (_payload, resolve = noop, reject = noop) => ({ resolve, reject }), // Meta
    ],
    PRESENCE_GET: [
      (payload) => payload, // Payload
      (_payload, resolve = noop, reject = noop) => ({ resolve, reject }), // Meta
    ],
    PRESENCE_SET_OTHERS_SIMULTANEOUS_RINGING: [
      (payload) => payload, // Payload
      (_payload, resolve = noop, reject = noop) => ({ resolve, reject }), // Meta
    ],

    PRESENCE_SET_WORKLOAD_SETTINGS: [
      (payload) => payload,
      (_payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
  },

  'PRESENCE_SET_STATUS_SUCCEEDED',
  'PRESENCE_SET_STATUS_FAILED',

  'APP_PRESENCE_SUCCEEDED',
  'APP_PRESENCE_FAILED',

  'PRESENCE_SET_MEDIA_CHANNEL_SUCCEEDED',
  'PRESENCE_SET_MEDIA_CHANNEL_FAILED',

  'PRESENCE_SET_MEDIA_SUCCEEDED',
  'PRESENCE_SET_MEDIA_FAILED',

  'PRESENCE_SET_SIMULTANEOUS_RINGING_SUCCEEDED',
  'PRESENCE_SET_SIMULTANEOUS_RINGING_FAILED',

  'PRESENCE_SET_OTHERS_SIMULTANEOUS_RINGING_SUCCEEDED',
  'PRESENCE_SET_OTHERS_SIMULTANEOUS_RINGING_FAILED',

  'PRESENCE_GET_SUCCEEDED',
  'PRESENCE_GET_FAILED',

  'PRESENCE_WS_AGENT_STATUS_CHANGED',
  'PRESENCE_WS_SET_OWN_STATUS',

  'PRESENCE_SHOW_OFFLINE',

  'PRESENCE_GET_WORKLOAD_SETTINGS',
  'PRESENCE_GET_WORKLOAD_SETTINGS_SUCCEEDED',
  'PRESENCE_GET_WORKLOAD_SETTINGS_FAILED',

  'PRESENCE_SET_WORKLOAD_SETTINGS_SUCCEEDED',
  'PRESENCE_SET_WORKLOAD_SETTINGS_FAILED',
);
